import React from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Avatar, Box, Button, Stack, Typography, useTheme } from '@mui/material';
import ScrollBox from '../../../components/ScrollBox';
import BackButton from '../../../components/BackButton';
import LabelTxt from '../../../components/LabelTxt';
import route from '../../../utils/Routes';
import BlurImg from '../../../components/BlurImg';
import { getFileUrl } from '../../../services/s3-service';
import { useQuery, useQueryClient } from 'react-query';
import { formatName, formatUserType, isNotEmpty } from '../../../utils/format';
import { useEffect } from 'react';
import QueryKey from '../../../utils/QueryKey';
import { useAuthContext } from '../../../context/AuthContext';
import { approveUserServ, getSingleComUserServ } from '../../../services/com-service';
import ComProjCard from '../../../components/ComProjCard';
import BgBoxOld from '../../../components/BgBoxOld';
import { customAlert, notify } from '../../../components/notify';
import { rmvProjFromUserServ } from '../../../services/proj-service';
import constants from '../../../utils/Constants';
import { useState } from 'react';
import LogoutPopup from '../../../components/LogoutPopup';
import { rmvEmpFromDept } from '../../../services/dept-service';
import StyledSwitch from '../../../components/StyledSwitch';
import { updateEmpStatusServ } from '../../../services/amtc-service';
import EditUsernameMdl from '../../ComUser/EditUsernameMdl';

function ComUserProfilePage({ type = "myinfo" }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const queryClient = useQueryClient();
    const [searchParams] = useSearchParams();
    const qUserId = searchParams.get("userId");
    const { setLoadingScreen, setNavComValue, ctxtUser, setAsyncLoading, ctxtlogout } = useAuthContext();
    const userId = type === "myinfo" ? ctxtUser?.userId : qUserId;
    const [lgOpen, setLgOpen] = useState(false);
    const detailstyle = { display: "inline-block", fontSize: 13, fontWeight: 400, mt: 2, width: 350 }
    const namestyle = { fontSize: 13, fontWeight: 500, mt: 2, display: "inline-block", width: 120 }

    const { isLoading, isError, error, data: userData, refetch } = useQuery([QueryKey.comUserProfile, userId],
        () => getSingleComUserServ(userId),
        {
            enabled: isNotEmpty(userId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        });

    const { isLoading: isImgLoading, data: imgUrl } = useQuery([QueryKey.img, userData?.profileImg],
        () => getFileUrl({ fileKey: userData?.profileImg }), {
        enabled: isNotEmpty(userData?.profileImg),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const [usernameMdl, setUsernameMdl] = useState(false);
    const handleUsernameMdlClose = () => setUsernameMdl(false);
    const handleUsernameMdlOpen = () => setUsernameMdl(true);

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        setLoadingScreen(isImgLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isImgLoading]);

    useEffect(() => {
        if (userData?.comId)
            setNavComValue({ comId: userData?.comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, userData]);


    async function handleProdRmvClick(i) {
        setLoadingScreen(true);
        try {
            const payload = {
                userId,
                projIdStrg: i.projIdStrg
            }
            const { message } = await rmvProjFromUserServ(payload);
            notify("success", message);
            queryClient.invalidateQueries();
            navigate(`${route.aComUserProfile}/?userId=${userId}`, { replace: true });
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    async function handleDeptUserRmvClick(i) {
        setLoadingScreen(true);
        try {
            const payload = {
                userId,
                deptId: i?.deptId
            }
            const { message } = await rmvEmpFromDept(payload);
            notify("success", message);
            queryClient.invalidateQueries();
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    async function handleUserApproveClick() {
        setLoadingScreen(true);
        try {
            const { message } = await approveUserServ(userId);
            notify("success", message);
            queryClient.invalidateQueries();
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    function handleEditBtnClick() {
        if (ctxtUser?.userType === constants.admin)
            navigate(route.aComEditUser, { state: { userId } });
        else if (ctxtUser?.userType === constants.focalPoint)
            navigate(route.cEditDeptEmp, { state: { userId } });
    };

    function handleLgOpen() {
        setLgOpen(true)
    }

    function handleLgClose() {
        setLgOpen(false)
    }

    async function handleLogout() {
        try {
            setAsyncLoading(true);
            await ctxtlogout();
            setAsyncLoading(false);
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
    }

    async function updateEmpStatus(i) {
        setAsyncLoading(true);
        try {
            let status = i.status === 1 ? 0 : 1;
            const isComUser = constants.comUserArr.includes(i?.userType);
            const { message } = await updateEmpStatusServ({ userId: i.userId, status, isComUser });
            notify("success", message);
            refetch();
        } catch (err) {
            console.log(err);
            customAlert(err)
        }
        setAsyncLoading(false)
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <ScrollBox height={"100%"} width={"100%"}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%", mb: 1 }}>
                <BackButton width={"30%"} />
                <Stack width={"40%"} alignItems={"center"}>
                    <Typography style={{ fontSize: 18, fontWeight: 500 }} >{type === "myinfo" ? "My Profile" : "Employee Profile"}</Typography>
                </Stack>
                <Stack direction={"row"} alignItems={"center"} width={"30%"} justifyContent={"end"}>
                    {(type === "user" && ctxtUser?.userType === constants.admin && userData?.isApproved === 0)
                        && <Button variant='contained' onClick={handleUserApproveClick} sx={{
                            fontSize: 13, color: "white", bgcolor: "green", height: 30, mr: 2
                        }}>
                            Approve</Button>}
                    {type === "myinfo" && <Button onClick={handleLgOpen} variant="contained"
                        sx={{ borderRadius: 2, backgroundColor: "red", width: 100, fontSize: 14, color: "white", padding: 0.1, }}>
                        LOGOUT</Button>}
                    {(type === "user" && ctxtUser?.userType === constants.admin && userData?.userType !== constants.admin) &&
                        <Stack direction={"row"} alignItems={"center"} gap={2}>
                            <Button variant='contained' onClick={handleUsernameMdlOpen} sx={{
                                fontSize: 13, bgcolor: theme?.palette?.custom?.btn, height: 30, color: "white"
                            }}>Update Username</Button>
                            <Button variant='outlined' onClick={handleEditBtnClick} sx={{
                                fontSize: 13,
                                color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                            }}>
                                Edit Info</Button>
                        </Stack>
                    }
                    {(type === "user" && ctxtUser?.userType === constants.focalPoint && userData?.userType !== constants.focalPoint && userData?.userType !== constants.lineManager)
                        && <Button variant='outlined' onClick={handleEditBtnClick} sx={{
                            fontSize: 13, ml: 5,
                            color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                        }}>
                            Edit Info</Button>}

                </Stack>
            </Stack>
            <BgBoxOld height={"93%"} py={1}>
                <Stack direction={"row"} width={"100%"} justifyContent={"space-between"} height={"100%"} position={"relative"}>
                    <Stack sx={{}}>
                        <Stack direction={"row"} sx={{ alignItems: "center" }} gap={2} mt={2}>
                            <Avatar sx={{ height: 90, width: 90 }} >
                                <BlurImg imgUrl={imgUrl} alt={"profile_image"} />
                            </Avatar>
                            <Typography sx={{ fontSize: 15, fontWeight: 500 }}>{formatName(userData?.fName, userData?.lName)}</Typography>
                        </Stack>
                        <LabelTxt typoname={"Employee ID"} typodetail={userData?.empId} overflow={40} namestyle={namestyle} detailstyle={detailstyle} />
                        <LabelTxt typoname={"Employee Role"} typodetail={formatUserType(userData?.userType)} overflow={40} namestyle={namestyle} detailstyle={detailstyle} />
                        <LabelTxt typoname={"Email ID"} typodetail={userData?.username} overflow={40} namestyle={namestyle} detailstyle={detailstyle} />
                        <LabelTxt typoname={"Contact No"} typodetail={userData?.phoneNo} overflow={40} namestyle={namestyle} detailstyle={detailstyle} />
                    </Stack>
                    <Stack alignItems={"start"} width={"60%"}>
                        <Typography sx={{ fontSize: 16, fontWeight: 500 }}>Project Details</Typography>
                        <Typography sx={{ fontSize: 14, fontWeight: 400, color: "rgba(0,0,0,0.8)", mt: 1 }}>Current Projects </Typography>
                        <ScrollBox height={"30%"} width={"100%"} pr={1}>
                            {(userData?.currProj || []).map((i, index) =>
                                ctxtUser?.userType === constants.admin ? <ComProjCard i={i} key={index} width={"100%"}
                                    type={"curr"}
                                    handleRmvClick={(userData?.userType === constants.focalPoint || userData?.userType === constants.lineManager) ? handleProdRmvClick : handleDeptUserRmvClick} />
                                    :
                                    ctxtUser?.userType === constants.focalPoint ? <ComProjCard i={i} key={index} width={"100%"}
                                        type={(userData?.userType === constants.requestor || userData?.userType === constants.approver) && "curr"}
                                        handleRmvClick={(userData?.userType === constants.requestor || userData?.userType === constants.approver) && handleDeptUserRmvClick} />
                                        :
                                        <ComProjCard i={i} key={index} width={"100%"} />)}

                        </ScrollBox>
                        <Box border={0.3} borderColor="rgba(0,0,0,0.05)" width={"100%"} my={0.3} />
                        <Typography sx={{ fontSize: 14, fontWeight: 400, color: "rgba(0,0,0,0.8)", mt: 1 }}>Previous Projects </Typography>
                        <ScrollBox height={"51%"} width={"100%"} pr={1}>
                            {(userData?.prevProjRes || []).map((i, index) =>
                                <ComProjCard i={i} key={index} width={"100%"} type={"prev"} />)}
                        </ScrollBox>
                    </Stack>
                    <Box sx={{
                        bgcolor: userData?.isApproved === 1 ? "rgba(0, 120, 10,0.4)" : "orange", position: "absolute", fontSize: 12,
                        fontWeight: 500, px: 2, py: 0.2, borderRadius: 16, left: -60, top: -8
                    }}>
                        {formatUserType(userData?.isApproved)}
                    </Box>
                    <Box position={"absolute"} left={-50} top={10}>
                        <StyledSwitch checked={userData?.status === 1 ? true : false} onClick={() => { updateEmpStatus(userData) }}
                            disabled={(ctxtUser?.userType === constants.admin) ? false : true} />
                    </Box>
                </Stack>
            </BgBoxOld>
            <LogoutPopup open={lgOpen} handleClose={handleLgClose} handleLogout={handleLogout} />
            {userData && <EditUsernameMdl modalOpen={usernameMdl} handleModalClose={handleUsernameMdlClose} userData={userData} />}
        </ScrollBox>
    )
}

export default ComUserProfilePage
